export default __webpack_public_path__ + "static/media/plinqr.5eb178f5.png";